import { HttpErrorResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { AuthService } from 'src/app/authentication/commons/services/services-auth/auth.service';
import { AuthSessionService } from '@shared/services/auth-session/auth-session.service';
import { NotifyService } from '@shared/services/notify/notify.service';
import { handleHttpError } from '@shared/utils/handle-http-error.util';

@Injectable({ providedIn: 'root' })
export class SessionLogoutService {
	private logoutInProgress = false;

	constructor(
		private readonly authSessionService: AuthSessionService,
		private readonly authService: AuthService,
		private readonly notifyService: NotifyService,
		private readonly router: Router
	) {}

	logout(): void {
		if (this.logoutInProgress) return;

		this.logoutInProgress = true;
		this.authSessionService.clear();

		this.authService.logout().subscribe({
			next: () => this.goHome(),
			error: (error: HttpErrorResponse) => {
				this.showHttpError(error);
				this.goHome();
			}
		});
	}

	private goHome(): void {
		this.logoutInProgress = false;
		void this.router.navigate(['/home']);
	}

	private showHttpError(error: HttpErrorResponse): void {
		const { notifyTitle, notifyMessage, notifyType } = handleHttpError(error);

		this.notifyService.show({
			title: notifyTitle,
			message: notifyMessage,
			type: notifyType
		});
	}
}
